<template>
    <!-- 集中檢核 資料與他人重複提示燈箱 -->
    <PopupBase v-model:visiblePopup="visibleCheckPopup">
        <template #title>
            {{ title }}
        </template>
        <template #content>
            <div v-html="content" />
        </template>
        <template #action>
            <button
                class="btn btn-accent rounded-full"
                @click="closeCheckPopup"
            >
                {{ cancelBtn }}
            </button>
            <button
                class="btn gradient-primary rounded-full"
                @click="handleConfirm"
            >
                {{ confirmBtn }}
            </button>
        </template>
    </PopupBase>
</template>

<script>
import { ref, watch } from 'vue';
import { postCheckBDP } from '@/apis/otpCheck';
import PopupBase from '@/components/dialogs/Popup.vue';

export default {
    components: {
        PopupBase
    },
    props: {
        postApiCheckBDP: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['update:visible', 'update:postApiCheckBDP', 'confirm', 'close'],
    setup(props, { emit }) {
        const title = ref('');
        const content = ref('');
        const confirmBtn = ref('');
        const cancelBtn = ref('');
        const checkBDPMessage = ref('');
        const checkBDPErrorItem = ref('');
        const visibleCheckPopup = ref(false);
        /** 確認 */
        const handleConfirm = () => {
            visibleCheckPopup.value = false;
            emit('confirm');
        };

        /** 資料重複燈箱關閉 */
        const closeCheckPopup = () => {
            visibleCheckPopup.value = false;
            emit('close');
        };

        /** 確認輸入資料是否與他人重複 */
        watch(() => props.postApiCheckBDP, (newV) => {
            if (newV) {
                postCheckBDP().then(res => {
                    if (res.data.errorItem) {
                        checkBDPErrorItem.value = res.data.errorItem;
                        title.value = '請確認';
                        // content.value = '請再次確認您本次申請變更的保單' + checkBDPErrorItem.value + '資料是否正確。';
                        // confirmBtn.value = '確認無誤';
                        // cancelBtn.value = '重填變更內容';

                        content.value = checkBDPErrorItem.value.replace(/\n/g,"<br>");
                        confirmBtn.value = '確定';
                        cancelBtn.value = '返回修改';
                        visibleCheckPopup.value = true;
                    } else if (res.data.message) {
                        checkBDPMessage.value = res.data.message;
                        title.value = '請確認';
                        content.value = '提醒您，公司會使用您保單的電話、地址、EMAIL來通知您保單重要的事項，例如繳費通知、滿期通知…等。若保單留存的聯絡資訊錯誤可能導致無法接收到通知，將可能影響您的權益。提醒您確認留存於本公司之聯絡資訊(包含地址/電話/手機/電子信箱)為您本人所有，並請勿與他人使用相同之聯絡資訊。<br><br>請再次確認您本次申請變更的' + checkBDPMessage.value + '資料是否正確，若正確無誤請點選「確定」；若需調整內容，請點選「取消」。<br><br>後續審核時若有需請您協助提供證明文件，將再請業務同仁與您聯繫。';
                        confirmBtn.value = '確認';
                        cancelBtn.value = '取消';
                        // popup
                        visibleCheckPopup.value = true;
                    } else {
                        title.value = '請確認';
                        emit('confirm');
                    };
                }).catch(() => {
                    emit('close');
                }).finally(() => {
                    emit('update:postApiCheckBDP', false);
                });
            }
        }, { immediate: true, deep: true });

        return {
            title,
            content,
            confirmBtn,
            checkBDPMessage,
            cancelBtn,
            closeCheckPopup,
            handleConfirm,
            visibleCheckPopup
        };
    },
};
</script>
